import { getCognitoHostedUIUrl } from '../config/api';

// Generate random state for CSRF protection
export function generateState(): string {
  const array = new Uint8Array(32);
  crypto.getRandomValues(array);
  return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
}

// Store state in sessionStorage
export function storeState(state: string): void {
  sessionStorage.setItem('oauth_state', state);
}

// Validate and retrieve state
export function validateState(state: string): boolean {
  const stored = sessionStorage.getItem('oauth_state');
  if (stored && stored === state) {
    sessionStorage.removeItem('oauth_state');
    return true;
  }
  return false;
}

// Login - redirect to Cognito Hosted UI
export function login(): void {
  try {
    const state = generateState();
    storeState(state);
    const url = getCognitoHostedUIUrl(state);
    window.location.replace(url);
  } catch (error) {
    console.error('Error in login:', error);
    alert('Failed to initiate login. Check console for details.');
  }
}

// Logout
export function logout(): void {
  localStorage.removeItem('session_id');
  sessionStorage.clear();
  // TODO: Call backend logout endpoint to invalidate session
  window.location.href = '/login';
}

